import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {PatientService} from '../../../modules/patient/patient.service';
import {Globals} from '../../../globals';
import {TdoSearchEvent} from '../../../tdo-controls/common/tdo-search/models/TdoSearchEvent';

export class InternalMessagingPersonModel {
  // mode can be user or patient
  mode: string;
  users: TdoUserConfigurationModel[];
  patients: PatientDataModel[];

  selectedUsers: TdoUserConfigurationModel[] = [];
  selectedPatient: PatientDataModel;
}

@Component({
  selector: 'app-internal-messaging-person-select-dialog',
  templateUrl: './internal-messaging-person-select-dialog.component.html',
  styleUrls: ['./internal-messaging-person-select-dialog.component.scss']
})
export class InternalMessagingPersonSelectDialogComponent implements OnInit {
  filteredUsers: TdoUserConfigurationModel[] = [];
  filteredPatients: PatientDataModel[] = [];

  constructor(private dialogRef: MatDialogRef<InternalMessagingPersonSelectDialogComponent>,
              private globals: Globals,
              private patientService: PatientService,
              @Inject(MAT_DIALOG_DATA) public data: InternalMessagingPersonModel) {
  }

  ngOnInit(): void {
    if (this.data.mode === 'patient') {
      this.filteredPatients = this.data.patients.concat();
    } else {
      this.filteredUsers = this.data.users.concat();
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.data);
  }

  isUserItemSelected(user: TdoUserConfigurationModel) {
    return this.data.selectedUsers.includes(user);
  }

  onUserSelect(user: TdoUserConfigurationModel) {
    if (!this.data.selectedUsers.includes(user)) {
      this.data.selectedUsers.push(user);
    } else {
      const idx = this.data.selectedUsers.findIndex(p => p === user);
      if (idx > -1) {
        this.data.selectedUsers.splice(idx, 1);
      }
    }
  }

  onPatientSelect(patient: PatientDataModel) {
    this.data.selectedPatient = patient;
  }

  isPatientItemSelected(patient: PatientDataModel) {
    return this.data.selectedPatient === patient;
  }

  onSearchChange(event: TdoSearchEvent) {
    if (this.data.mode === 'patient') {
      // Possibly split event value by spaces, and handle each word separate
      this.filteredPatients = this.data.patients.filter(p => p.dataContact.FirstName?.toLowerCase().includes(event.value.toLowerCase()) || p.dataContact.LastName?.toLowerCase().includes(event.value.toLowerCase()) || p.dataContact.MidName?.toLowerCase().includes(event.value.toLowerCase()));
    } else {
      this.filteredUsers = this.data.users.filter(p => p.UserName?.toLowerCase().includes(event.value.toLowerCase()) || p.UserName?.toLowerCase().includes(event.value.toLowerCase()) || p.UserName?.toLowerCase().includes(event.value.toLowerCase()));
    }
  }

  onSearchCleared(event: any) {
    if (this.data.mode === 'patient') {
      // Possibly split event value by spaces, and handle each word separate
      this.filteredPatients = this.data.patients.concat();
    } else {
      this.filteredUsers = this.data.users.concat();
    }
  }
}
